import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CampaignClass, CampaignLabelMap } from '@feathr/blackbox';
import { AlertV2 as Alert, Button, EAlertV2Type } from '@feathr/components';
import CampaignTypeChip from '@feathr/extender/components/CampaignTypeChip';

import * as styles from './PixlPlusUpsell.css';

interface IPixlPlusUpsellProps {
  originalCampaignType: CampaignClass;
  handleContinueWithSelection: () => void;
  isMonetization?: boolean;
}

function PixlPlusUpsell({
  originalCampaignType,
  handleContinueWithSelection,
  isMonetization,
}: Readonly<IPixlPlusUpsellProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <table className={styles.table}>
        <thead>
          <tr>
            {/* Force an empty column for the first row */}
            <th>{t('')}</th>
            <th>
              <CampaignTypeChip
                cls={originalCampaignType ?? CampaignClass.Segment}
                isMonetization={isMonetization}
              />
            </th>
            <th>
              <CampaignTypeChip cls={CampaignClass.Omni} isMonetization={isMonetization} />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t('Omnitargeting')}</td>
            <td>{t('Limited')}</td>
            <td>{t('Expanded')}</td>
          </tr>
          <tr>
            <td>{t('Audience targeting')}</td>
            <td>
              {originalCampaignType === CampaignClass.EmailList
                ? t('Only email addresses')
                : t('Only cookies')}
            </td>
            <td>{t('All available targets')}</td>
          </tr>
          <tr>
            <td>{t('Interest filtering')}</td>
            <td>{t('Not included')}</td>
            <td>{t('Included')}</td>
          </tr>
        </tbody>
      </table>

      <Alert
        className={styles.alert}
        description={[
          t('Target all available identifiers in your audience'),
          t('Expanded cross-device targeting'),
          t('Filter your audience by interests'),
        ]}
        title={t('Benefits of Pixl Plus')}
        type={EAlertV2Type.info}
      />

      <Button onClick={handleContinueWithSelection}>
        {t('Continue with {{type}}', {
          type: CampaignLabelMap.get(originalCampaignType ?? CampaignClass.Segment),
        })}
      </Button>
    </>
  );
}

export default PixlPlusUpsell;
